import { render, staticRenderFns } from "./itemoption.vue?vue&type=template&id=3678e923&scoped=true&"
import script from "./itemoption.vue?vue&type=script&lang=js&"
export * from "./itemoption.vue?vue&type=script&lang=js&"
import style0 from "./itemoption.vue?vue&type=style&index=0&id=3678e923&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3678e923",
  null
  
)

export default component.exports